module.exports = __webpack_public_path__ + "media/img/pages/career-starter/regions/aargau-bee180e2593af162bea0e2b6c5935357.png";